import * as React from "react";
import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline, Snackbar, Alert } from "@mui/material";
import theme from "./Themes/theme";
import { MockDataProvider } from "./contexts/MockDataContext";
import LoginPage from "./ScreenLayouts/Auth/Login";
import { Routes, Route, Navigate } from "react-router-dom";
import CustomerDashboard from "./ScreenLayouts/AdminType/Dashboard/CustomerDash";
import PartnerDashboard from "./ScreenLayouts/AdminType/Dashboard/PartnerDash";
import InsightsDashboard from "./ScreenLayouts/AdminType/Dashboard/InsightsDashboard";
import Profile from "./ScreenLayouts/General/Profile";
import CustomerOrganisations from "./ScreenLayouts/AdminType/Customers/Organisations";
import NewCustomerOrganisations from "./ScreenLayouts/AdminType/Customers/NewOrganisation";
import CustomerOrganisationUsers from "./ScreenLayouts/AdminType/Customers/Users";
import NewCustomerOrganisationUser from "./ScreenLayouts/AdminType/Customers/NewUser";
import PartnerOrganisations from "./ScreenLayouts/AdminType/Partners/Organisations";
import NewPartnerOrganisations from "./ScreenLayouts/AdminType/Partners/NewOrganisation";
import PartnerOrganisationUsers from "./ScreenLayouts/AdminType/Partners/Users";
import NewPartnerOrganisationUser from "./ScreenLayouts/AdminType/Partners/NewUser";
import ChannelPartnerList from "./ScreenLayouts/AdminType/ChannelPartners/ChannelPartnerList";
import ChannelPartnerOnboarding from "./ScreenLayouts/AdminType/ChannelPartners/ChannelPartnerOnboarding";
import CommissionConfig from "./ScreenLayouts/AdminType/ChannelPartners/CommissionConfig";
import ChannelPartnerDetail from "./ScreenLayouts/AdminType/ChannelPartners/ChannelPartnerDetail";
import ChannelPartnerUsers from "./ScreenLayouts/AdminType/ChannelPartners/ChannelPartnerUsers";
import ChannelPartnerUserAdd from "./ScreenLayouts/AdminType/ChannelPartners/ChannelPartnerUserAdd";

// Payment Gateway Components
import {
  GatewayListPage,
  CustomerConfigPage,
  GatewayCostAnalysis,
  TopupRequestsPage
} from "./Components/finance/PaymentGateways";

// Thaklis Finance Components
import {
  ThaklisDashboard,
  EnhancedTransactions,
  CommissionPayments,
  BankAccounts,
  PaymentApprovals,
  PaymentFlow,
  ThaklisMasterWallet,
  ThaklisFinanceOverview
} from "./ScreenLayouts/AdminType/Finance";

import NewServiceGroup from "./ScreenLayouts/AdminType/ServiceGroup/NewGroup";
import NewService from "./ScreenLayouts/AdminType/Service/NewService";
import CustomerServiceMapping from "./ScreenLayouts/AdminType/Customers/ServiceMapping";
import TicketFormWrapper from "./ScreenLayouts/Common/Ticket/NewTicket/TicketFormWrapper";
// import MyTickets from "./ScreenLayouts/Common/Ticket/MyTickets"; // Commented out - unused
import PendingTickets from "./ScreenLayouts/AdminType/Ticket/PendingTickets";
import TicketDetailView from "./ScreenLayouts/AdminType/Ticket/TicketDetailView";
import CustomerTicketList from "./ScreenLayouts/CustomerType/Ticket/CustomerTicketList";
import MyTickets from "./ScreenLayouts/CustomerType/MyTickets";
import TicketDetails from "./ScreenLayouts/Common/Ticket/TicketDetails";
import CustomerOrgDashboard from "./ScreenLayouts/CustomerOrganisation/Dashboard";
import ServiceGroups from "./ScreenLayouts/AdminType/ServiceGroup/List";
import Services from "./ScreenLayouts/AdminType/Service/list";
import CustomerServiceMappings from "./ScreenLayouts/AdminType/Customers/ServiceMappings";
import PartnerServiceMapping from "./ScreenLayouts/AdminType/Partners/ServiceMapping";
import PartnerServiceMappings from "./ScreenLayouts/AdminType/Partners/ServiceMappings";
import TopupRequest from "./ScreenLayouts/AdminType/Wallet/TopupRequest";
import InvoiceRequests from "./ScreenLayouts/AdminType/Invoice/InvoceRequests";
import AccountStatements from "./ScreenLayouts/AdminType/AccountManagement/AccountStatements";
import PaymentMethods from "./ScreenLayouts/AdminType/ApplicationConfigurations/PaymentMethods";
import MyWallet from "./ScreenLayouts/Common/Wallet/MyWallet";
import ServicePartnerPaymentPage from "./ScreenLayouts/Common/Wallet/ServicePartnerPaymentPage";
import ChannelPartnerPaymentPage from "./ScreenLayouts/Common/Wallet/ChannelPartnerPaymentPage";
import CustomerPaymentsPage from "./ScreenLayouts/Common/Wallet/CustomerPaymentsPage";
import CustomerWallets from "./ScreenLayouts/AdminType/Wallet/CustomerWallets";
import PartnerBankAccountManagement from "./ScreenLayouts/Common/Wallet/PartnerBankAccounts";
import PendingCustomerTickets from "./ScreenLayouts/AdminType/Customers/Ticket/PendingCustomerTickets";
import MyInvoices from "./ScreenLayouts/Common/Invoice/MyInvoices";
import AccountSummary from "./ScreenLayouts/AdminType/AccountManagement/AccountSummary";
import AccountManagement from "./ScreenLayouts/AdminType/AccountManagement";
import AccountMenu from "./ScreenLayouts/AdminType/AccountManagement/AccountMenu";
import Payments from "./ScreenLayouts/AdminType/AccountManagement/Payments";
import RelatedTickets from "./ScreenLayouts/AdminType/AccountManagement/RelatedTickets";

// Phase 3 Financial Components
// Finance components - temporarily commented out due to path resolution issues
// import WalletDashboard from './components/finance/WalletDashboard';
// import InvoiceList from './components/finance/InvoiceList';
// import InvoiceViewer from './components/finance/InvoiceViewer';

// Using test component for the wallet dashboard that we know works
//import TestWalletDashboard from './TestWalletDashboard';
import PendingPartnerTickets from "./ScreenLayouts/AdminType/Partners/Ticket/PendingPartnerTickets";
import PartnerOrgDashboard from "./ScreenLayouts/PartnerType/Dashboard";
import CommissionDashboard from "./ScreenLayouts/PartnerType/Commission/CommissionDashboard";
import ReferredCustomers from "./ScreenLayouts/PartnerType/Commission/ReferredCustomers";
import CommissionByService from "./ScreenLayouts/PartnerType/Commission/CommissionByService";
import PaymentHistory from "./ScreenLayouts/PartnerType/Commission/PaymentHistory";
import MonthlyStatement from "./ScreenLayouts/PartnerType/Commission/MonthlyStatement";
import CustomerPaymentMethod from "./ScreenLayouts/CustomerOrganisation/CustomerPaymentMethod";
import CustomerPaymentMethodEdit from "./ScreenLayouts/CustomerOrganisation/CustomerPaymentMethodEdit";
import EditCustomerOrganisation from "./ScreenLayouts/AdminType/Customers/EditOrganisation";
import EditCustomerUser from "./ScreenLayouts/AdminType/Customers/EditUser";
import EditTicket from "./ScreenLayouts/Common/Ticket/EditTicket";
import ResetPasssword from "./ScreenLayouts/Common/ResetPassword";
import EditPartnerUser from "./ScreenLayouts/AdminType/Partners/EditUser";
import ChangePassword from "./ScreenLayouts/AdminType/UserManagement/ChangePassword";
import NewAgent from "./ScreenLayouts/AdminType/Agent/NewAgent";
import AgentUsers from "./ScreenLayouts/AdminType/Agent/Users";
import EditAgentUser from "./ScreenLayouts/AdminType/Agent/EditUser";
import PartnerPayment from "./ScreenLayouts/AdminType/Partners/Payment";
import PendingPartnerPayments from "./ScreenLayouts/PartnerType/PendingPayments";
import PartnerPaymentDashboard from "./ScreenLayouts/PartnerType/PaymentDashboard";
import CustomerOrganizationConfig from "./ScreenLayouts/AdminType/Customers/OrganizationConfig";
import IssuesDashboard from "./ScreenLayouts/AdminType/SystemIssues";
import OnBeahalfTicket from "./ScreenLayouts/AdminType/Customers/OnBeahalfTicket";
import ReplyForm from "./ScreenLayouts/AdminType/Ticket/ReplyForm";
import CloseOnBehalfTicket from "./ScreenLayouts/AdminType/Ticket/CloseOnBehalfTicket";
import CustomerPaymentMethods from "./ScreenLayouts/CustomerOrganisation/CustomerPaymentMethods";
import AppLayout2 from "./LayoutContainers/AppLayout2";
import NewUID from "./ScreenLayouts/General/NewUid";
import { UidDirectory } from "./ScreenLayouts/General/UidDirectory";
import AdminProfile from "./ScreenLayouts/General/Profile/AdminProfile";

// Enhanced Wallet Topup
import EnhancedWalletTopup from "./ScreenLayouts/CustomerType/Wallet/EnhancedWalletTopup";

// Pending Approvals Demo
import PendingApprovalsDemo from "./ScreenLayouts/Common/Wallet/PendingApprovalsDemo";
import PendingApprovalsPage from "./ScreenLayouts/Common/Wallet/PendingApprovalsPage";
import TransactionHistoryPage from "./ScreenLayouts/Common/Wallet/TransactionHistoryPage";

// Form Design Demo
import ModernFormDesignDemo from "./Components/WorkflowFields/ModernFormDesignDemo";

// Workflow Management Components
import {
  WorkflowList,
  WorkflowDetail,
  WorkflowAssignment,
  WorkflowInstanceList,
  WorkflowInstanceDetail,
  // WorkflowCreator, // Commented out - unused
  BasicWorkflowCreator
} from "./ScreenLayouts/AdminType/Workflow";

// Organization Configuration Components
import {
  OrganizationConfigList,
  OrganizationConfigForm,
  OrganizationConfigView
} from "./ScreenLayouts/AdminType/OrganizationConfig";

// Subscription Components
import {
  SubscriptionPlansList,
  SubscriptionPlanForm
} from "./ScreenLayouts/AdminType/SubscriptionPlans";
import {
  OrganizationSubscriptionsList,
  OrganizationSubscriptionView
} from "./ScreenLayouts/AdminType/OrganizationSubscriptions";
import { SubscriptionPage } from "./ScreenLayouts/CustomerType/Subscription";

// System Configuration Components
import ConfigurationMain from "./ScreenLayouts/AdminType/Configuration/ConfigurationMain";

// Organization Document Configuration
import DocConfigMain from "./ScreenLayouts/AdminType/DocConfig";
import BusinessCategoriesPage from "./ScreenLayouts/AdminType/DocConfig/BusinessCategories/BusinessCategoriesPage";

// Customer Organization Documents
import OrganizationDocumentsPage from "./ScreenLayouts/CustomerType/OrganizationDocuments";
import RequiredDocumentsPage from "./ScreenLayouts/CustomerType/OrganizationDocuments/RequiredDocumentsPage";

// Customer Company Profile
import CompanyProfile from "./ScreenLayouts/CustomerType/CompanyProfile";

// Customer Tax Services
import { TaxServicesPage, MyTaxRequestsPage, TaxStatusPage } from "./ScreenLayouts/CustomerType/TaxServices";

// Customer Document Services (Organization Services)
import { MyDocumentRequestsPage } from "./ScreenLayouts/CustomerType/DocumentServices";
import OrgTicketRequest from "./ScreenLayouts/CustomerType/DocumentServices/OrgTicketRequest";

// Admin Organization Documents Reports
import { ExpiringDocumentsReport, MissingDocumentsReport } from "./ScreenLayouts/AdminType/OrganizationDocuments";

// Customer Workflow Request Components
import {
  NewWorkflowRequest,
  WorkflowRequestList,
  WorkflowRequestDetails,
  WorkflowRequestTickets,
  // WorkflowTicketsList, // Commented out - unused
  MultiServiceWorkflowGenerator
} from "./ScreenLayouts/CustomerType/Workflow";

// Customer Dashboard Components
import CustomerDocumentsDashboard from "./ScreenLayouts/CustomerType/Dashboard";
import AgentChat from "./ScreenLayouts/CustomerType/Agent/AgentChat";
import AgentConfigPage from "./ScreenLayouts/AdminType/Agent/AgentConfig";
import AgentUsagePage from "./ScreenLayouts/AdminType/Agent/AgentUsage";
import LegalDashboard from "./ScreenLayouts/CustomerType/Dashboard/LegalDashboard";
import TrainingDashboard from "./ScreenLayouts/CustomerType/Dashboard/TrainingDashboard";
import FinancialDashboard from "./ScreenLayouts/CustomerType/Dashboard/FinancialDashboard";
import CustomerAdminDashboard from "./ScreenLayouts/CustomerType/Dashboard/CustomerAdminDashboard";
import CustomerDashTabs from "./ScreenLayouts/CustomerType/Dashboard/CustomerDashTabs";
import DocumentReportEmailPanel from "./ScreenLayouts/CustomerType/Dashboard/DocumentReportEmailPanel";
import ExpiringDocumentsPage from "./ScreenLayouts/AdminType/Reports/ExpiringDocuments/ExpiringDocumentsPage";
import MissingDocumentsPage from "./ScreenLayouts/AdminType/Reports/MissingDocuments/MissingDocumentsPage";
import StorageUsagePage from "./ScreenLayouts/AdminType/Reports/StorageUsage/StorageUsagePage";

// Employee Management Components
import EmployeeList from "./ScreenLayouts/CustomerType/Employees/EmployeeList";
import EmployeeCreate from "./ScreenLayouts/CustomerType/Employees/EmployeeCreate";
import EmployeeDetail from "./ScreenLayouts/CustomerType/Employees/EmployeeDetail";
import EmployeeEdit from "./ScreenLayouts/CustomerType/Employees/EmployeeEdit";
import DocumentManagement from "./ScreenLayouts/CustomerType/Employees/DocumentManagement";
import EmployeeDocumentProfile from "./ScreenLayouts/CustomerType/Employees/EmployeeDocumentProfile";
import EmployeeLoginActivation from "./ScreenLayouts/CustomerType/Employees/EmployeeLoginActivation";
import ForgotPage from "./ScreenLayouts/Auth/ForgotPassword";
import ResetPasswordPage from "./ScreenLayouts/Auth/ResetPassword";
import { NotificationProvider } from "./contexts/NotificationContext";
import NgeniusReturnPage from "./ScreenLayouts/Common/Payments/NgeniusReturnPage";
import NgeniusCancelledPage from "./ScreenLayouts/Common/Payments/NgeniusCancelledPage";

// Force token reset function
const forceTokenReset = () => {
  console.log('FORCE TOKEN RESET: Clearing all authentication data');

  // Clear all known token storage keys
  const tokenKeys = [
    'token',
    'jwt_token',
    'refresh_token',
    'authToken',
    'authInfo',
    'currentUser',
    'organizationCode',
    'userId',
    'userEmail',
    'userRoles'
  ];

  // Clear localStorage
  tokenKeys.forEach(key => {
    try {
      localStorage.removeItem(key);
      console.log(`FORCE TOKEN RESET: Cleared localStorage.${key}`);
    } catch (e) {
      console.error(`FORCE TOKEN RESET: Error clearing localStorage.${key}:`, e);
    }
  });

  // Clear sessionStorage
  tokenKeys.forEach(key => {
    try {
      sessionStorage.removeItem(key);
      console.log(`FORCE TOKEN RESET: Cleared sessionStorage.${key}`);
    } catch (e) {
      console.error(`FORCE TOKEN RESET: Error clearing sessionStorage.${key}:`, e);
    }
  });

  // Clear authInfo object but keep its structure
  try {
    const authInfo = localStorage.getItem('authInfo');
    if (authInfo) {
      const authInfoObj = JSON.parse(authInfo);
      const cleanAuthInfo = {};

      // Keep structure but remove sensitive data
      Object.keys(authInfoObj).forEach(key => {
        if (['token', 'refreshToken', 'user', 'userId', 'email', 'organizationCode'].includes(key)) {
          cleanAuthInfo[key] = null;
        } else {
          cleanAuthInfo[key] = authInfoObj[key];
        }
      });

      localStorage.setItem('authInfo', JSON.stringify(cleanAuthInfo));
      console.log('FORCE TOKEN RESET: Cleared authInfo sensitive data');
    }
  } catch (e) {
    console.error('FORCE TOKEN RESET: Error clearing authInfo:', e);
  }

  console.log('FORCE TOKEN RESET: All authentication data has been reset');
  return true;
};

export default function MyApp() {
  // const [tokenResetComplete, setTokenResetComplete] = React.useState(false); // Commented out - unused
  const [showResetNotification, setShowResetNotification] = React.useState(false);

  // Force token reset when app loads
  useEffect(() => {
    // Reset all tokens - commented out to prevent authentication clearing
    // forceTokenReset();
    // setTokenResetComplete(true); // Commented out - unused
    // Disabled notification since we disabled the token reset
    setShowResetNotification(false);

    // Make the function available globally for debugging
    window.forceTokenReset = forceTokenReset;

    // Add event listener to detect page reload and navigation
    const handleBeforeUnload = () => {
      // Store a flag indicating we're reloading
      sessionStorage.setItem('reloading', 'true');
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    // Check if we're coming back from a reload
    const isReloading = sessionStorage.getItem('reloading') === 'true';
    if (isReloading) {
      // Clear the flag
      sessionStorage.removeItem('reloading');
      // Commented out to prevent authentication clearing after reload
      // forceTokenReset();
    }

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  // Handle notification close
  const handleCloseNotification = () => {
    setShowResetNotification(false);
  };

  return (
    <Sentry.ErrorBoundary fallback={<div style={{padding: 40, textAlign: 'center'}}>Something went wrong. Please refresh the page.</div>}>
    <MockDataProvider>
      {/* Token reset notification */}
      <Snackbar
        open={showResetNotification}
        autoHideDuration={3000}
        onClose={handleCloseNotification}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseNotification} severity="info" sx={{ width: '100%' }}>
          Authentication reset complete. Please login with your credentials.
        </Alert>
      </Snackbar>
      <ThemeProvider theme={theme}>
        <CssBaseline />
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        {/* Direct ticket access route */}
        <Route path="/tickets/:id" element={<TicketDetailView />} />
        {/* NGenius payment return pages (outside auth wrapper - redirected from external payment page) */}
        <Route path="/payment/ngenius/return" element={<NgeniusReturnPage />} />
        <Route path="/payment/ngenius/cancelled" element={<NgeniusCancelledPage />} />
        <Route element={
          <NotificationProvider>
            <AppLayout2 />
          </NotificationProvider>
        }>
          <Route path="ADM-Wallet">
            <Route path="payment_methods" element={<PaymentMethods />} />
            <Route path="topup-request" element={<PaymentApprovals />} />
            <Route path="account-management" element={<AccountMenu />} />
          </Route>
          <Route path="ADM-Invoice">
            <Route path="invoice-request" element={<InvoiceRequests />} />
          </Route>
          <Route path="ADM-Invoice">
            <Route path="invoice-request" element={<InvoiceRequests />} />
          </Route>
          <Route path="ADM-Dash">
            <Route path="customer" element={<CustomerDashboard />} />
            <Route path="partner" element={<PartnerDashboard />} />
            <Route path="insights" element={<InsightsDashboard />} />
          </Route>
          <Route path="ADM-Customer">
            <Route path="adm-customer-organisations" element={<CustomerOrganisations />} />
            <Route path="adm-new-customer-organisation" element={<NewCustomerOrganisations />} />
            <Route path="adm-edit-customer-organisation" element={<EditCustomerOrganisation />} />
            <Route path="adm-customer-users" element={<CustomerOrganisationUsers />} />
            <Route path="adm-new-customer-user" element={<NewCustomerOrganisationUser />} />
            <Route path="adm-edit-customer-user" element={<EditCustomerUser />} />
            <Route path="adm-customer-service-mapping" element={<CustomerServiceMapping />} />
            <Route path="adm-customer-service-mappings" element={<CustomerServiceMappings />} />
            <Route path="adm-customer-organization-config" element={<CustomerOrganizationConfig />} />
            <Route path="pending-customer-tickets" element={<PendingCustomerTickets />} />
          </Route>
          <Route path="ADM-Partner">
            <Route path="adm-partner-organisations" element={<PartnerOrganisations />} />
            <Route path="adm-new-partner-organisation" element={<NewPartnerOrganisations />} />
            <Route path="adm-partner-users" element={<PartnerOrganisationUsers />} />
            <Route path="adm-new-partner-user" element={<NewPartnerOrganisationUser />} />
            <Route path="adm-edit-partner-user" element={<EditPartnerUser />} />
            <Route path="adm-partner-service-mapping" element={<PartnerServiceMapping />} />
            <Route path="adm-partner-service-mappings" element={<PartnerServiceMappings />} />
            <Route path="pending-tickets" element={<PendingPartnerTickets />} />
            <Route path="partner-payment" element={<PartnerPayment />} />
          </Route>
          <Route path="ADM-ChannelPartners">
            <Route path="adm-channel-partner-list" element={<ChannelPartnerList />} />
            <Route path="adm-new-channel-partner" element={<ChannelPartnerOnboarding />} />
            <Route path="adm-commission-config" element={<CommissionConfig />} />
            <Route path="adm-channel-partner-detail" element={<ChannelPartnerDetail />} />
            <Route path="adm-channel-partner-users" element={<ChannelPartnerUsers />} />
            <Route path="adm-new-channel-partner-user" element={<ChannelPartnerUserAdd />} />
          </Route>
          <Route path="admin">
            <Route path="payment-gateways" element={<GatewayListPage />} />
            <Route path="customer-gateway-config" element={<CustomerConfigPage />} />
            <Route path="gateway-cost-analysis" element={<GatewayCostAnalysis />} />
            <Route path="topup-requests" element={<TopupRequestsPage />} />
          </Route>
          <Route path="admin/finance">
            <Route path="overview" element={<ThaklisFinanceOverview />} />
            <Route path="master-wallet" element={<ThaklisMasterWallet />} />
            <Route path="payment-flow" element={<PaymentFlow />} />
            <Route path="dashboard" element={<ThaklisDashboard />} />
            <Route path="transactions" element={<EnhancedTransactions />} />
            <Route path="commissions" element={<CommissionPayments />} />
            <Route path="payment-approvals" element={<PaymentApprovals />} />
            <Route path="bank-accounts" element={<BankAccounts />} />
          </Route>
          <Route path="ADM-Account">
            <Route path="statements" element={<AccountStatements />} />
          </Route>
          {/* Customer Employee Routes */}
          <Route path="my-tickets" element={<MyTickets />} />
          <Route path="profile" element={<Profile />} />
          <Route path="dashboard" element={<CustomerOrgDashboard />} />
          <Route path="ADM-Account">
            <Route path="wallet" element={<MyWallet />} />
            <Route path="management" element={<AccountMenu />} />
            <Route path="invoices" element={<InvoiceRequests />} />
          </Route>
          <Route path="account">
            <Route path="statements" element={<AccountStatements />} />
            <Route path="wallet" element={<MyWallet />} />
            <Route path="management" element={<AccountMenu />} />
            <Route path="invoices" element={<InvoiceRequests />} />
          </Route>
          <Route path="ADM-ServiceGroup">
            <Route path="adm-new-serviceGroup" element={<NewServiceGroup />} />
            <Route path="adm-serviceGroups" element={<ServiceGroups />} />
          </Route>
          <Route path="ADM-Service">
            <Route path="adm-new-service" element={<NewService />} />
            <Route path="adm-services" element={<Services />} />
          </Route>
          <Route path="ADM-Ticket">
            <Route path="new-ticket" element={<TicketFormWrapper />} />
            <Route path="edit-ticket" element={<EditTicket />} />
            <Route path="pending-tickets" element={<PendingTickets />} />
            <Route path="ticket-details" element={<TicketDetails />} />
            <Route path="ticket-detail-view" element={<TicketDetailView />} />
            <Route path="on-behalf-ticket" element={<OnBeahalfTicket />} />
            <Route path="reply-form" element={<ReplyForm />} />
            <Route path="close-on-behalf-ticket" element={<CloseOnBehalfTicket />} />
          </Route>
          <Route path="ADM-Wallet">
            <Route path="payment_methods" element={<PaymentMethods />} />
            <Route path="topup-request" element={<PaymentApprovals />} />
            <Route path="account-management" element={<AccountMenu />} />
          </Route>
          <Route path="ADM-Invoice">
            <Route path="invoice-request" element={<InvoiceRequests />} />
          </Route>
          <Route path="ADM-Invoice">
            <Route path="invoice-request" element={<InvoiceRequests />} />
          </Route>
          <Route path="ADM-APPCONFIG">
            <Route path="reset_password" element={<ResetPasssword />} />
          </Route>
          <Route path="ADM-USER-MGMNT">
            <Route path="change-password" element={<ChangePassword />} />
            <Route path="reset_password" element={<ResetPasssword />} />
          </Route>
          {/* AI Agent Admin */}
          <Route path="ADM-AIAgent">
            <Route path="chat" element={<AgentChat />} />
            <Route path="config" element={<AgentConfigPage />} />
            <Route path="usage" element={<AgentUsagePage />} />
          </Route>

          <Route path="ADM-AGENT">
            <Route path="agent-creation" element={<NewAgent />} />
            <Route path="agent-users" element={<AgentUsers />} />
            <Route path="edit-agent-user" element={<EditAgentUser />} />
          </Route>
          <Route path="ADM-System">
            <Route path="issues" element={<IssuesDashboard />} />
          </Route>
          <Route path="ADM-Configuration">
            <Route path="main" element={<ConfigurationMain />} />
            <Route path="field-categories" element={<ConfigurationMain />} />
          </Route>
          <Route path="ADM-DocConfig">
            <Route path="main" element={<DocConfigMain />} />
            <Route path="business-categories" element={<BusinessCategoriesPage />} />
          </Route>
          {/* Subscription plan catalog (Admin) */}
          <Route path="ADM-SubscriptionPlans">
            <Route index element={<SubscriptionPlansList />} />
            <Route path="create" element={<SubscriptionPlanForm />} />
            <Route path="edit/:id" element={<SubscriptionPlanForm />} />
          </Route>
          {/* Per-organisation subscriptions (Admin) */}
          <Route path="ADM-OrgSubscriptions">
            <Route index element={<OrganizationSubscriptionsList />} />
            <Route path="view/:orgId" element={<OrganizationSubscriptionView />} />
          </Route>
          {/* Organization Document Reports (Admin) */}
          <Route path="ADM-OrgDocReports">
            <Route path="expiring" element={<ExpiringDocumentsReport />} />
            <Route path="missing" element={<MissingDocumentsReport />} />
          </Route>
          <Route path="ADM-Reports">
            <Route path="documents" element={<ExpiringDocumentsPage />} />
            <Route path="missing-documents" element={<MissingDocumentsPage />} />
            <Route path="storage" element={<StorageUsagePage />} />
          </Route>
          <Route path="wallet">
            <Route path="my-wallet" element={<MyWallet />} />
            <Route path="topup" element={<EnhancedWalletTopup />} />
            <Route path="my-invoices" element={<MyInvoices />} />
            <Route path="new_customer_payment_method" element={<CustomerPaymentMethod />} />
            <Route path="payment_methods" element={<CustomerPaymentMethods />} />
            <Route path="edit_customer_payment_method/:id" element={<CustomerPaymentMethodEdit />} />
            <Route path="pending-partner-payment" element={<PendingPartnerPayments />} />
            <Route path="payment-dashboard" element={<PartnerPaymentDashboard />} />
            <Route path="customer-payment-methods" element={<CustomerPaymentMethods />} />
            <Route path="approvals-demo" element={<PendingApprovalsDemo />} />
            <Route path="pending-approvals" element={<PendingApprovalsPage />} />
            <Route path="transaction-history" element={<TransactionHistoryPage />} />
            {/* Using test wallet dashboard since the original has import issues */}

            <Route path="account-management" element={<AccountManagement />} />

            {/* Invoice routes temporarily commented out due to import issues */}
            {/* <Route path="invoices" element={<InvoiceList />} /> */}
            {/* <Route path="invoice/:invoiceId" element={<InvoiceViewer />} /> */}
          </Route>

          {/* New Account section routes */}
          <Route path="account">
            <Route path="management" element={<AccountSummary />} />
            <Route path="wallet" element={<MyWallet />} />
            <Route path="wallet/topup" element={<EnhancedWalletTopup />} />
            <Route path="invoices" element={<MyInvoices />} />
            <Route path="my-invoices" element={<MyInvoices />} />
            <Route path="statements" element={<AccountStatements />} />
            <Route path="payments" element={<Payments />} />
            <Route path="related-tickets" element={<RelatedTickets />} />
          </Route>

          {/* Wallet payment pages */}
          <Route path="wallet">
            <Route path="customer-wallets" element={<CustomerWallets />} />
            <Route path="service-partner-payments" element={<ServicePartnerPaymentPage />} />
            <Route path="channel-partner-commissions" element={<ChannelPartnerPaymentPage />} />
            <Route path="customer-payments" element={<CustomerPaymentsPage />} />
          </Route>
          <Route path="profile" element={<Profile />} />
          <Route path="cst">
            <Route path="dash" element={<CustomerDashTabs />}>
              <Route index element={<Navigate to="documents" replace />} />
              <Route path="documents" element={<CustomerDocumentsDashboard />} />
              <Route path="insights" element={<InsightsDashboard />} />
              <Route path="financial" element={<FinancialDashboard />} />
            </Route>
            {/* Customer Configuration - Organisation Configuration */}
            <Route path="configuration" element={<OrganizationConfigList />} />
            {/* Customer Subscription */}
            <Route path="subscription" element={<SubscriptionPage />} />
            {/* Customer Admin Profile */}
            <Route path="my-profile" element={<AdminProfile />} />
          </Route>
          <Route path="ptr">
            <Route path="dash" element={<PartnerOrgDashboard />} />
          </Route>
          {/* Partner Bank Account Management */}
          <Route path="partner">
            <Route path="bank-accounts" element={<PartnerBankAccountManagement />} />
          </Route>
          {/* Commission Routes for Channel Partner */}
          <Route path="commission">
            <Route path="dashboard" element={<CommissionDashboard />} />
            <Route path="customers" element={<ReferredCustomers />} />
            <Route path="by-service" element={<CommissionByService />} />
            <Route path="payment-history" element={<PaymentHistory />} />
            <Route path="monthly-statement" element={<MonthlyStatement />} />
          </Route>
          <Route path="CM">
            {/* <Route path="reset_password" element={<ResetPasssword />} /> */}
          </Route>
          <Route path="USER_MGMT">
            <Route path="new_uid" element={<NewUID />} />
            <Route path="uid_directory" element={<UidDirectory />} />
          </Route>
          <Route path="ADM-Workflow">
            <Route path="list" element={<WorkflowList />} />
            <Route path=":id" element={<WorkflowDetail />} />
            <Route path=":id/assign" element={<WorkflowAssignment />} />
            <Route path="instance" element={<WorkflowInstanceList />} />
            <Route path="instance/:id" element={<WorkflowInstanceDetail />} />
          </Route>
          <Route path="admin/workflow">
            <Route path="create" element={<BasicWorkflowCreator />} />
            <Route path="list" element={<WorkflowList />} />
            <Route path=":id" element={<WorkflowDetail />} />
            <Route path=":id/edit" element={<BasicWorkflowCreator />} />
            <Route path=":id/assign" element={<WorkflowAssignment />} />
          </Route>
          <Route path="admin/workflows" element={<WorkflowList />} />
          <Route path="admin/organization-config">
            <Route path="" element={<OrganizationConfigList />} />
            <Route path="create" element={<OrganizationConfigForm />} />
            <Route path="edit/:id" element={<OrganizationConfigForm isEdit={true} />} />
            <Route path="view/:id" element={<OrganizationConfigView />} />
          </Route>
          {/* AI Assistant */}
          <Route path="CST-Agent">
            <Route path="chat" element={<AgentChat />} />
          </Route>

          <Route path="CST-Workflow">
            <Route path="requests" element={<WorkflowRequestList />} />
            <Route path="requests/:id" element={<WorkflowRequestDetails />} />
            <Route path="requests/:id/details" element={<WorkflowRequestDetails />} />
            <Route path="requests/:id/tickets" element={<WorkflowRequestTickets />} />
            <Route path="new-request" element={<NewWorkflowRequest />} />
            <Route path="multi-service-generator" element={<MultiServiceWorkflowGenerator />} />
          </Route>
          <Route path="CST-Dashboard">
            <Route path="documents" element={<CustomerDocumentsDashboard />} />
            <Route path="legal" element={<LegalDashboard />} />
            <Route path="training" element={<TrainingDashboard />} />
            <Route path="financial" element={<FinancialDashboard />} />
            <Route path="admin" element={<CustomerAdminDashboard />} />
            <Route path="reports" element={<ExpiringDocumentsPage />} />
            <Route path="missing-documents" element={<MissingDocumentsPage />} />
            <Route path="report-email" element={<DocumentReportEmailPanel />} />
            <Route path="workforce" element={<CustomerDocumentsDashboard />} /> {/* Placeholder - will be replaced with WorkforceDashboard in Phase 2 */}
          </Route>

          {/* New Employee Management Routes */}
          <Route path="CST-Employees">
            <Route path="list" element={<EmployeeList />} />
            <Route path="create" element={<EmployeeCreate />} />
            <Route path="detail/:id" element={<EmployeeDetail />} />
            <Route path="edit/:id" element={<EmployeeEdit />} />
            <Route path="documents/:id" element={<DocumentManagement />} />
            <Route path="document-profile/:uid" element={<EmployeeDocumentProfile />} />
            <Route path="detail/:employeeId/activate-login" element={<EmployeeLoginActivation />} />
          </Route>

          {/* Stakeholder Management Routes - reuse employee components with mode="stakeholder" */}
          <Route path="CST-Stakeholders">
            <Route path="list" element={<EmployeeList mode="stakeholder" />} />
            <Route path="create" element={<EmployeeCreate mode="stakeholder" />} />
            <Route path="detail/:id" element={<EmployeeDetail mode="stakeholder" />} />
            <Route path="edit/:id" element={<EmployeeEdit mode="stakeholder" />} />
            <Route path="document-profile/:uid" element={<EmployeeDocumentProfile />} />
            <Route path="detail/:employeeId/activate-login" element={<EmployeeLoginActivation />} />
          </Route>

          {/* Organization Documents Routes */}
          <Route path="CST-OrgDocuments">
            <Route path="list" element={<OrganizationDocumentsPage />} />
            <Route path="required" element={<RequiredDocumentsPage />} />
          </Route>

          {/* Company Profile Route */}
          <Route path="CST-Organization">
            <Route path="profile" element={<CompanyProfile />} />
          </Route>

          {/* Tax Services Routes */}
          <Route path="CST-TaxServices">
            <Route path="requests" element={<MyTaxRequestsPage />} />
            <Route path="status" element={<TaxStatusPage />} />
            <Route path="list" element={<TaxServicesPage />} />
          </Route>

          {/* Document Services Routes (Organization Services) */}
          <Route path="CST-DocServices">
            <Route path="requests" element={<MyDocumentRequestsPage />} />
            <Route path="new-request" element={<OrgTicketRequest />} />
          </Route>

          {/* Form Design Demo Route */}
          <Route path="mod">
            <Route path="modern-form-demo" element={<ModernFormDesignDemo />} />
          </Route>

          <Route path="ticket">
            <Route path="my-tickets" element={<CustomerTicketList />} />
            <Route path="ticket-details" element={<TicketDetails />} />
          </Route>
        </Route>
        <Route path="/new" element={<AppLayout2 />}></Route>
        {/* Direct access to insights */}
        <Route path="/insights" element={<InsightsDashboard />} />
      </Routes>
      </ThemeProvider>
    </MockDataProvider>
    </Sentry.ErrorBoundary>
  );
}
